module.exports = __webpack_public_path__ + "static/media/zoomy5_preview.38fedbba.jpg";